import React, { useState, useEffect } from 'react';
import TrimSelector from '../../../2_Molecules/TrimSelector/TrimSelector';
import { convertCurrency } from '../../../../utils/helpers';
import { handleRequest } from '../../../../utils/httpRequest';
import generalController from '../../../../controllers/generalController';
import { getApiBaseUrl } from '../../../../utils/endPoints';

interface TrimType {
  name: string;
  url_slug: string;
}

interface Trim {
  trim_type: TrimType;
  visual: any;
}

interface Carline {
  title: string;
  url_slug: string;
}

interface Year {
  title: string;
  url_slug: string;
}

interface ModelYear {
  show_brochure?: boolean;
}

interface VehicleData {
  trim: Trim;
  model_code: string;
  option_code: string;
  carline: Carline;
  year: Year;
  model_year?: ModelYear;
  specifications?: any;
}

interface ModelData {
  [trimSlug: string]: VehicleData;
}

interface TrimOption {
  slug: string;
  trim: string;
  name: string;
}

interface PriceInfo {
  [trimSlug: string]: string;
}

interface TrimSelectorsCarouselProps {
  modelData: ModelData;
  trimsOrder: string[];
  trimsOptions: TrimOption[];
  activeSlide: number;
  setTrimsOrder: (order: string[]) => void;
  setActiveSlide: (slide: number) => void;
  updateTrimsOrder?: (index: number, value: string) => void;
  showDesignYoursButton: boolean;
}

const TrimSelectorsCarousel: React.FC<TrimSelectorsCarouselProps> = ({
  modelData,
  trimsOrder,
  trimsOptions,
  activeSlide,
  setTrimsOrder,
  setActiveSlide,
  showDesignYoursButton
}) => {
  // TODO: Remove this line when the specs API response includes the price info.
  const [tempPriceInfo, setTempPriceInfo] = useState<PriceInfo>({});

  const updateTrimsOrder = (index: number, value: string) => {
    const newOrder = [...trimsOrder];
    newOrder[index] = value;
    setTrimsOrder(newOrder);
  };

  // TODO: Remove this whole useEffect when the specs API response includes the price info.
  useEffect(() => {
    const getPriceByModel = async () => {
      const prices: PriceInfo = {};
      const province = generalController.getMetatagValue('province');
      const language = generalController.detectLanguage();

      for (const trimName of trimsOrder) {
        const trimData = modelData[trimName];
        const { model_code, option_code } = trimData;
        const url = `${getApiBaseUrl()}/api/Financial/${model_code}/${option_code}?prov_code=${province}&lang_code=${language}`;
        const data = await handleRequest('get', url);

        if (data.data && data.data.msrp) {
          prices[trimName] = convertCurrency(data.data.msrp, language);
        }
      }
      
      setTempPriceInfo(prices);
      window.dispatchEvent(new Event('resize'));
    };

    if (modelData && trimsOrder) {
      getPriceByModel();
    }
  }, [modelData, trimsOrder]);

  return (
    <thead className="mz-table-head">
      <tr>
        {/* Items */}
        {
          trimsOrder.map((trimName, index) => {
            const trimData = modelData[trimName];
            const { trim, model_year, year, carline } = trimData;
            if (tempPriceInfo[trimName] !== undefined) {
              return (
                <TrimSelector
                  key={index}
                  index={index}
                  modelYearData={trim.visual}
                  yearData={year}
                  modelName={carline?.url_slug}
                  defaultTrim={trim?.trim_type.url_slug}
                  trim={trim.trim_type.name}
                  trimOptions={trimsOptions}
                  trimPrice={tempPriceInfo[trimName]}
                  updateTrimsOrder={() => updateTrimsOrder(index, trimName)}
                  showDesignYoursButton={showDesignYoursButton}
                />
              );
            }
            return null;
          })
        }
      </tr>
    </thead>
  );
};

export default TrimSelectorsCarousel;
